import "./PromoPageComponentSkeleton.scss";
import DiscountSkeleton from './PromoDiscount/DiscountSkeleton';
import FAQsSkeleton from '../FAQsSection/FAQsSkeleton';

const PromoPageComponentSkeleton = () => {

    return (
        <div className='promo__wrapper__skeleton'>
            <div className='promo__hero__skeleton'>
                <div className='promo__hero__cover__skeleton'>
                    <div className='promo__hero__content__skeleton'>
                        <div className='promo__hero__content__accent__skeleton'></div>
                        <div className='promo__hero__content__title__skeleton'></div>
                        <div className='promo__hero__content__subtitle__skeleton'></div>
                        <div className='promo__hero__content__text__skeleton'></div>
                    </div>
                    <div className='promo__hero__timer__skeleton'>
                        <div className='promo__hero__timer__accent__skeleton'></div>
                        <div className="promo__timer__numbers__skeleton">
                            {[...Array(4)].map((_, index) => (
                                <div key={index} className="numbers__item__skeleton"></div>
                            ))}
                        </div>
                        <div className="promo__timer__labels__skeleton">
                            {[...Array(4)].map((_, index) => (
                                <div key={index} className="labels__item__skeleton"></div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
            <div className='promo__description__skeleton'>
                <div className="promo__description__left__skeleton">
                    <div className="promo__description__left__content__skeleton">
                        <div className="promo__description__left__content__title__skeleton"></div>
                        <div className="promo__description__left__content__subtitle__skeleton"></div>
                        <div className="promo__description__left__content__subtitle__skeleton--primary"></div>
                        <div className="promo__description__left__content__button__skeleton"></div>
                    </div>
                </div>
                <div className="promo__description__right__skeleton">
                    {[...Array(3)].map((_, index) => (
                        <div key={index} className="promo__description__right__item__skeleton">
                            {[...Array(2)].map((_, index) => (
                                <div key={index} className="promo__description__right__text__skeleton"></div>
                            ))}
                            <div className="promo__description__right__text__skeleton--primary"></div>
                        </div>
                    ))}
                </div>
            </div>
            <DiscountSkeleton />
            <div className='promo__steps__skeleton'>
                <div className='promo__steps__title__skeleton'></div>
                <div className="promo__steps__item__subtitle__skeleton"></div>
                <div className='promo__steps__item__wrapper__skeleton'>
                    {[...Array(3)].map((_, index) => (
                        <div key={index} className='promo__steps__item__skeleton'>
                            <div className="steps__icon__skeleton"></div>
                            <div className='promo__steps__item__title__skeleton'></div>
                            {[...Array(2)].map((_, index) => (
                                <div key={index} className='promo__steps__item__text__skeleton'></div>
                            ))}
                            <div className='promo__steps__item__text__skeleton--primary'></div>
                        </div>
                    ))}
                </div>
            </div>
            <div className='promo__banner__wrapper__skeleton'>
                <div className='promo__banner__skeleton'>
                    <div className='promo__banner__title__skeleton'></div>
                    <div className='promo__banner__subtitle__skeleton'></div>
                    <div className='promo__banner__button__skeleton'></div>
                </div>
            </div>
            <FAQsSkeleton />
        </div>
    )
}


export default PromoPageComponentSkeleton;